import { createRef } from 'react';
import Link from '@/components/Link';
import useHover from '@/hooks/useHover';

export default function PostListing({
  uri,
  title,
  excerpt,
  featuredImage,
}) {
  const target = createRef();
  const isHovering = useHover(target);

  return (
    <Link href={uri} className="flex transition ease-in-out duration-200 relative rounded w-full" ref={target}>
      <div className="relative z-10 flex flex-col w-full">
        <div
          className="w-full h-0 bg-gray-100 h-50 bg-center bg-cover overflow-hidden rounded-t transition-cpu"
          style={{
            paddingTop: 'calc((9% / 16) * 100)',
            transition: 'clip-path 0.25s ease-in-out,-webkit-clip-path 0.25s ease-in-out',
            clipPath: isHovering ? 'inset(0% 0% 0 0% round 4px 4px 0px 0px)' : 'inset(8% 4% 0 4% round 4px 4px 4px 4px)',
            backgroundImage: `url('${featuredImage?.node?.sourceUrl}')`,
          }}
        />
        <div className="flex flex-col space-y-2 lg:space-y-4 py-8 px-8 rounded-b">
          <h2 className="font-medium text-lg">
            {title}
          </h2>
          <div className="lg:h-20 xl:h-28 overflow-hidden relative">
            <div
              className="prose font-normal"
              dangerouslySetInnerHTML={{ __html: excerpt }}
            />
            <div className="w-full absolute bottom-0 left-0 right-0 h-4 bg-gradient-to-t from-white to-transparent" />
          </div>
        </div>
      </div>
      <div
        className="absolute inset-0 bg-white shadow-xl rounded z-0 transform transition-cpu"
        style={{
          opacity: isHovering ? '1' : '0',
          transition: 'transform 0.31s ease-in-out,opacity .17s ease-in-out',
          transform: isHovering ? 'scale(1)' : 'scale(.92)',
        }}    
      />
    </Link>
  );
}
